'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobUrlNotFound', cobUrlNotFound);

	function cobUrlNotFound() {

		return {
			restrict: 'E',
			scope: {},
			templateUrl: '/app/common/welcome/cobUrlNotFound.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction() {}

})();
